/**
 * Script relative toogle switch checkbox
 */

import breakpoints from '../misc/breakpoints';

// Flag permettant de savoir si on est en mobile ou en desktop
let switchFlag; // à l'initialisation = flag état neutre (ni true, ni false)

$(document).ready(function () {

    // au clic sur bouton toggle
    $('[data-toggle-switch]').click(function () {

      // ajoute la classe active
      $('[data-switch]').toggleClass('active');

      /**
       * Affiche/ masque la carte et la liste des storistes
       * Change l'état de l'attribut data-switch à 'active'
       */
      $('[data-switch]').attr('data-switch', function (index, attr) {
        $('[data-switch-target]').toggle();
        return attr === 'active' ? "" : 'active';
      });
    });

    // passe le flag à mobile
    switchFlag = true;

});

window.addEventListener('resize', function () {

  // en mobile
  if (breakpoints.isMobileLarge()) {
    // si le flag indique qu'on n'est pas en mobile
    if (switchFlag !== true) {
      // passe le flag à mobile
      switchFlag = true;

      // masque la liste des storistes
      $('[data-switch-target]:nth-of-type(2)').hide();
    }
  }
  // en desktop
  // si le flag est à mobile
  else if (switchFlag !== false) {
    // passe le flag à desktop
    switchFlag = false;

    // affiche tous les éléments (carte + liste des storistes)
    $('[data-switch-target]').show();
    // remet le bouton à son style et son état original
    $('[data-switch]').removeClass('active').attr('data-switch', '');
    // retire le check de la checkbox
    $('[data-toggle-switch]').prop('checked', false);
  }
});
